<style scoped lang="scss">
    @import "../../styles/var";
    @import "../../styles/mixins";

    .ava {
        @include w_h(70px);
    }
</style>
<template>
    <div class="info flex pl15 pr15 pt10 pb10 aic bb">
        <img src="../../assets/pat-default.png" alt="" class="ava flex0 radius50 mr15">
        <div class="flex1">
            <div class="flex aic">
                <span class="fs15 color_333 flex0">李明卫</span>
                <img src="../../assets/icon/consult/vip.png" alt="" class="flex0 ml5">
            </div>
            <div class="fs14 color_999 mt5">姓名：李明卫</div>
            <div class="fs14 color_999 mt5">男 34岁 浙江杭州</div>
        </div>
    </div>
</template>

<script>

  export default {
    name: "consult-pat-info",
    components: {},
    props: {
      list: Array,
    },
    data() {
      return {
        height: 0,
        active: 0
      }
    },
    computed: {},
    created() {
    },
    methods: {}
  }
</script>
